import { useMemo } from "react";
import { useSelector } from "react-redux";

import { LAYOUT_MIN_EXPORT_WIDTH } from "../constants";

// Warns the user that map elements might look off when the export frame is too small
const useIsExportWidthTooSmallForLayout = () => {
  const exportSize = useSelector((state) => {
    return state.app.exportSize;
  });
  const exportScale = useSelector((state) => {
    return state.app.exportScale;
  });
  const exportSelect = useSelector((state) => {
    return state.app.exportSelect;
  });
  const exportLayoutHasMapWidth = useSelector((state) => {
    return state.app.exportLayout?.properties?.mapWidth;
  });
  const isTooSmall = useMemo(() => {
    const [width] = exportSize || [];
    return exportSelect && exportLayoutHasMapWidth && width
      ? width * exportScale < LAYOUT_MIN_EXPORT_WIDTH * exportScale
      : false;
  }, [exportSize, exportScale, exportSelect, exportLayoutHasMapWidth]);
  return isTooSmall;
};

export default useIsExportWidthTooSmallForLayout;
